import Link from "next/link"
import Image from "next/image"
import DynamicVideo from "components/DynamicVideo"
import CallToAction from "components/CallToAction"
import Icon from "public/assets/icon.svg"
import track from "utilities/track"

export default function WideArticleCard({ video, eyebrow, category, description, image, title, link, cta_text }) {
  return (
    <div className="flex flex-col lg:flex-row shadow-xl">
      {video.id !== "" ? (
        <div className="lg:order-last lg:basis-2/3">
          <DynamicVideo component={video.component} image={image} {...video} title={title} />
        </div>
      ) : (
        <Link
          href={link}
          className="lg:order-last lg:basis-2/3"
          onClick={() => track({ event: "click_more_article_button", options: { article: title } })}
        >
          <Image
            className="aspect-video object-cover"
            src={image.filename}
            alt={image.alt}
            height={300}
            width={400}
            style={{ width: "100%", height: "auto" }}
          />
        </Link>
      )}

      <div className="bg-white p-8 lg:basis-1/3 lg:relative">
        <Icon className="hidden lg:block absolute bottom-0 right-0" />
        <div className="eyebrow">{eyebrow}</div>
        <Link href={link} onClick={() => track({ event: "click_more_article_button", options: { article: title } })}>
          <h3>{title}</h3>
        </Link>
        <div className="py-4">{description}</div>

        <CallToAction
          style="secondary"
          href={link}
          onClick={() => track({ event: "click_more_article_button", options: { article: title } })}
        >
          {cta_text}
        </CallToAction>
      </div>
    </div>
  )
}
